<template>
    <Link :href="'/'" class="flex items-center justify-center">
      <span class="hidden">LIVCK</span>
      <svg class="w-24 h-24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.28 47.31"><path class="a" d="M107,27.65l-6.27,25.41a1.7,1.7,0,0,1-3.3,0L96.66,50A1.7,1.7,0,0,0,95,48.67H85.39a1.69,1.69,0,0,0-1.62,2.18l6.5,21.61a1.7,1.7,0,0,0,1.63,1.21h14a1.7,1.7,0,0,0,1.63-1.21L120.9,28.55a1.69,1.69,0,0,0-1.62-2.19H108.65A1.68,1.68,0,0,0,107,27.65Z" transform="translate(-83.69 -26.36)"/></svg>
    </Link>
</template>

<script>
    import { defineComponent } from 'vue'
    import { Link } from '@inertiajs/inertia-vue3';

    export default defineComponent({
        components: {
            Link,
        },
    })
</script>

<style scoped>
.a{fill:#00e091;}
</style>
